import React from "react"

const BOARD_CONTENT = [
  "At first glance, we can see that AMZScout’s plans are less expensive than Jungle Scout’s. AMZScout users can get access to the full suite of tools for less than half of what it would cost to use the other platform.",
  "Another advantage AMZScout has over Jungle Scout is its lifetime plan. You can choose to make a one-time payment to get access to the platform for life. Jungle Scout does not have such an option.",
]
export default BOARD_CONTENT

